import { Component, OnInit } from '@angular/core';
import { ProcedureAssessmentsService } from 'src/app/services/procedure-assessments.service';
import { ToolsControlService } from 'src/app/services/tools-control.service';
import { MenuManagementService } from 'src/app/menu/services/menu-management.service';
import { CoordinatePointModel } from 'src/app/models/coordinate-point';
import { ProcedureCoordinatePointModel } from 'src/app/models/procedure-coordinate-point';
import { ProcedureLegModel } from 'src/app/models/procedure-leg';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { SaveProcedureAssessmentComponent } from 'src/app/popup/save-procedure-assessment/save-procedure-assessment.component';
import { cloneDeep } from 'lodash';
import { Feature } from 'ol';
import {unByKey} from 'ol/Observable';

import Point from 'ol/geom/Point';
import { ModalControlService } from 'src/app/services/modal-control.service';
import { SelectCoordinatePointsControlService } from 'src/app/popup/services/select-coordinate-points-control.service';
import { Coordinate } from 'ol/coordinate';
import { FeatureType } from 'src/app/models/EnumTypes';
import { PointsService } from 'src/app/services/points.service';
import { CalculationValidation } from 'src/app/services/calculation-validation.service';
import { TabsService } from 'src/app/services/tabsService';


@Component({
  selector: 'app-procedure-assessments',
  templateUrl: './procedure-assessments.component.html',
  styleUrls: ['./procedure-assessments.component.scss'],
  standalone: false
})
export class ProcedureAssessmentsComponent implements OnInit {

  public isSelected = false;
  private isOutOfFocus = false;

  constructor(
    public procedureAssessmentsController : ProcedureAssessmentsService,
    public toolsService : ToolsControlService,
    public menuController : MenuManagementService,
    private popupService : BsModalService,
    private modalService: ModalControlService,
    private pointsService : PointsService,
    private calculationValidation : CalculationValidation,
    public tabsService: TabsService
  ) { }

  ngOnInit(): void {
  }

  deselectFixPoint(){
    const selectedFixPoint = this.procedureAssessmentsController.fixPoints.find(fixPoint => fixPoint.coordPoint.isselected == true);
    selectedFixPoint != undefined ? selectedFixPoint.coordPoint.isselected = false: false;
  }
  deselectProcedureCoordinatePoint(){
    const selectedPCP = this.procedureAssessmentsController.procedureInterfaceToHTML.procedureCoordinatePoints.find(pcp => pcp.coordPoint.isselected == true);
    selectedPCP != undefined ? selectedPCP.coordPoint.isselected = false: false;
  }

  setPointer(){
    if (this.isOutOfFocus){
      this.procedureAssessmentsController.setPointer(true);
      this.isOutOfFocus = false;
    }
  }

  setOutOfFocus(){
    this.isOutOfFocus = true;
  }

  checkIfChange(coordPoint, index: number){
    if (Math.round(coordPoint.latitude * 100000) / 100000 != Math.round(this.procedureAssessmentsController.originalProcedure.procedureCoordinatePoints[index].coordPoint.latitude * 100000) / 100000 ||
    Math.round(coordPoint.longitude * 100000) / 100000 != Math.round(this.procedureAssessmentsController.originalProcedure.procedureCoordinatePoints[index].coordPoint.longitude * 100000) / 100000) {
        coordPoint.ismodified = true;
    } else {
      coordPoint.ismodified = false;
    }
  }

  isRedirectAllowed(index : number) : boolean {
    if (index == 0 || index == this.procedureAssessmentsController.procedureInterfaceToHTML.procedureCoordinatePoints.length-1){
      return false;
    }
    const startPointIndex = this.procedureAssessmentsController.procedureInterfaceToHTML.procedureLegs.findIndex(leg =>
      leg.startPoint.coordPoint.id == this.procedureAssessmentsController.procedureInterfaceToHTML.procedureCoordinatePoints[index].coordPoint.id);
    const endPointIndex = this.procedureAssessmentsController.procedureInterfaceToHTML.procedureLegs.findIndex(leg =>
      leg.endPoint.coordPoint.id == this.procedureAssessmentsController.procedureInterfaceToHTML.procedureCoordinatePoints[index].coordPoint.id);
    if (!this.procedureAssessmentsController.procedureInterfaceToHTML.procedureLegs[startPointIndex].isstraightleg){
      return false;
    }
    // check next leg
    if (startPointIndex + 1 < this.procedureAssessmentsController.procedureInterfaceToHTML.procedureLegs.length &&
      !this.procedureAssessmentsController.procedureInterfaceToHTML.procedureLegs[startPointIndex + 1].isstraightleg){
      return false;
    }
    if (!this.procedureAssessmentsController.procedureInterfaceToHTML.procedureLegs[endPointIndex].isstraightleg){
      return false;
    }
    // check prior leg
    if (endPointIndex - 1 >= 0 && !this.procedureAssessmentsController.procedureInterfaceToHTML.procedureLegs[endPointIndex - 1].isstraightleg){
      return false;
    }
    return true;
  }

  cancelWindow():void{
    this.procedureAssessmentsController.active = !this.procedureAssessmentsController.active;
    this.toolsService.navigationOnTop = false;
    this.procedureAssessmentsController.clearProcedureAssessment();
  }


  async openPerformanceAnalysisPopup(): Promise<void> {
    this.procedureAssessmentsController.loading = true;


    this.pointsService.getSelectedFeatures().forEach(feature => {
        if (feature.getProperties().featureType != FeatureType.Navaid){
          this.procedureAssessmentsController.pointsService.removeSelectedFeature(feature);
        }
      });
      const procedure = await this.procedureAssessmentsController.applyOffSetToProcedure(cloneDeep(this.procedureAssessmentsController.selectedProcedure));
      let procedureFeature = this.pointsService.createProcedureFeature(procedure);
      procedureFeature.setProperties({
        'type': this.procedureAssessmentsController.procedure.getProperties().type,
        'proceduretype': this.procedureAssessmentsController.procedure.getProperties().proceduretype,
        'name': this.procedureAssessmentsController.procedure.getProperties().name,
        'id': this.procedureAssessmentsController.procedure.getProperties().id,
        'procedureid' : this.procedureAssessmentsController.procedure.getProperties().procedureid
      })
      this.pointsService.addSelectedFeature(procedureFeature);
      this.calculationValidation.openPerformanceAnalysisPopupInitialization()
      this.procedureAssessmentsController.loading = false;



  }

  async openVerticalProfilePopup(): Promise<void> {
    this.procedureAssessmentsController.loading = true;
    this.pointsService.getSelectedFeatures().forEach(feature => {
      if (feature.getProperties().featureType != FeatureType.Navaid){
        this.pointsService.removeSelectedFeature(feature);
      }
    });
    const procedure = await this.procedureAssessmentsController.applyOffSetToProcedure(cloneDeep(this.procedureAssessmentsController.selectedProcedure));
    let procedureFeature = this.pointsService.createProcedureFeature(procedure);
    procedureFeature.setProperties({
      'type': this.procedureAssessmentsController.procedure.getProperties().type,
      'proceduretype': this.procedureAssessmentsController.procedure.getProperties().proceduretype,
      'featureType': this.procedureAssessmentsController.procedure.getProperties().featureType,
      'name': this.procedureAssessmentsController.procedure.getProperties().name,
      'id': this.procedureAssessmentsController.procedure.getProperties().id,
      'procedureid' : this.procedureAssessmentsController.procedure.getProperties().procedureid
    })
    this.pointsService.addSelectedFeature(procedureFeature);
    this.calculationValidation.openVerticalProfilePopupInitialization();
    this.procedureAssessmentsController.loading = false;
  }

  public updateProcedureCoordPoint(event) : void {
    this.procedureAssessmentsController.pointsService.deleteAssessmentProcedureFromMap(this.procedureAssessmentsController.selectedProcedure);
    this.procedureAssessmentsController.map.removeInteraction(this.procedureAssessmentsController.mapService.select);
    if (this.procedureAssessmentsController.eventKey != null){
      unByKey(this.procedureAssessmentsController.eventKey);
    }
    if (this.procedureAssessmentsController.dragInteraction != null){
      this.procedureAssessmentsController.map.removeInteraction(this.procedureAssessmentsController.dragInteraction);
    }
    const interfaceCP = this.procedureAssessmentsController.procedureInterfaceToHTML.procedureCoordinatePoints[(event.target.id).split(":")[1]].coordPoint;
    interfaceCP.latitude = Math.round(interfaceCP.latitude * 100000) / 100000;
    interfaceCP.longitude = Math.round(interfaceCP.longitude * 100000) / 100000;
    let cpIndex =this.procedureAssessmentsController.selectedProcedure.procedureCoordinatePoints.findIndex(pcp =>
      pcp.coordPoint.id == interfaceCP.id);
    if (cpIndex != -1){
      this.procedureAssessmentsController.selectedProcedure.procedureCoordinatePoints[cpIndex].coordPoint = interfaceCP;
    }
    let source = this.procedureAssessmentsController.pointsService.coordinatePointsLayers.childLayers[0].layers.find((element) => element.id === interfaceCP.type.toLowerCase())
    .olLayer.getSource();
    var feature:Feature = source.getFeatureById(interfaceCP.id);
    source.removeFeature(feature);
    feature.setProperties({
      'latitude': interfaceCP.latitude,
      'longitude': interfaceCP.longitude
    })
    this.procedureAssessmentsController.pointsService.addCoordinatePointToMap(this.procedureAssessmentsController.pointsService.transformFeatureInCoordinatePoint(feature), true);

    this.procedureAssessmentsController.setPointer();
    this.procedureAssessmentsController.updateProcedure(this.procedureAssessmentsController.selectedProcedure);

    const curveLegs = this.procedureAssessmentsController.procedureInterfaceToHTML.procedureLegs.filter(leg => (leg.startPoint.coordPoint.id == interfaceCP.id
      || leg.endPoint.coordPoint.id == interfaceCP.id) && !leg.isstraightleg );
    for (const curveLeg of curveLegs){
      curveLeg.curvePoints = [];
      this.procedureAssessmentsController.selectCoordinatePointService.calculateCurvePoints(curveLeg);
      this.procedureAssessmentsController.updateProcedure(this.procedureAssessmentsController.selectedProcedure, curveLeg.fixPoint.coordPoint);
    }
  }

  public updateFixPoint(event) : void {
    const fixPointIndex = (event.target.id).split(":")[1];
    const interfaceFixPoint = this.procedureAssessmentsController.fixPoints[fixPointIndex].coordPoint;
    interfaceFixPoint.latitude = Math.round(interfaceFixPoint.latitude * 100000) / 100000;
    interfaceFixPoint.longitude = Math.round(interfaceFixPoint.longitude * 100000) / 100000;
    let source = this.procedureAssessmentsController.pointsService.coordinatePointsLayers.childLayers[0].layers.find((element) => element.id === interfaceFixPoint.type.toLowerCase())
    .olLayer.getSource();
    let feature:Feature = source.getFeatureById(interfaceFixPoint.id);
    source.removeFeature(feature);
    feature.setProperties({
      'latitude': interfaceFixPoint.latitude,
      'longitude': interfaceFixPoint.longitude
    })
    this.procedureAssessmentsController.pointsService.addCoordinatePointToMap(this.procedureAssessmentsController.pointsService.transformFeatureInCoordinatePoint(feature), true);
    const legInterface = this.procedureAssessmentsController.legsNextToCurve.find(leg => leg.fixPoint != null && leg.fixPoint.coordPoint.id == interfaceFixPoint.id);
    legInterface.curvePoints = [];
    this.procedureAssessmentsController.selectCoordinatePointService.calculateCurvePoints(legInterface);
    this.procedureAssessmentsController.updateProcedure(this.procedureAssessmentsController.selectedProcedure, interfaceFixPoint);
  }

  public resetEspecificCoordinatePoint(event: ProcedureCoordinatePointModel) : void {
    if (event.isDeletedFromMap){
      const pcpExists = this.procedureAssessmentsController.selectedProcedure.procedureCoordinatePoints.some(pcp =>
        pcp.coordPoint.id == event.coordPoint.id);
      if (!pcpExists){
        this.procedureAssessmentsController.resetEspecificCoordinatePoint(event.coordPoint.id, this.procedureAssessmentsController.procedureInterfaceToHTML);
        return;
      }
    }
    this.procedureAssessmentsController.resetEspecificCoordinatePoint(event.coordPoint.id, this.procedureAssessmentsController.selectedProcedure);
    const curveLegs = this.procedureAssessmentsController.procedureInterfaceToHTML.procedureLegs.filter(leg => (leg.startPoint.coordPoint.id == event.coordPoint.id
      || leg.endPoint.coordPoint.id == event.coordPoint.id) && !leg.isstraightleg );
    for (const curveLeg of curveLegs){
      curveLeg.curvePoints = [];
      this.procedureAssessmentsController.selectCoordinatePointService.calculateCurvePoints(curveLeg);
      this.procedureAssessmentsController.updateProcedure(this.procedureAssessmentsController.selectedProcedure, curveLeg.fixPoint.coordPoint);
    }

  }

  public resetEspecificFixPoint(event: ProcedureCoordinatePointModel) : void {
    this.procedureAssessmentsController.resetEspecificFixPoint(event, true);
  }

  public resetEspecificOffset(event, leg: ProcedureLegModel, isResetAll?: boolean) : void {
    if (leg.ismodified){
      return;
    }
    if (event == null){
      const interfaceLeg = this.procedureAssessmentsController.procedureInterfaceToHTML.procedureLegs.find(leg2 =>
        leg2.startPoint.coordPoint.id == leg.startPoint.coordPoint.id &&
        leg2.endPoint.coordPoint.id == leg.endPoint.coordPoint.id);
      this.procedureAssessmentsController.resetEspecificOffset(leg, isResetAll);
      if (interfaceLeg != undefined){
        interfaceLeg.direction = "NotSet";
        interfaceLeg.offset = 0.0;
      }
    } else {
      const realLeg = this.procedureAssessmentsController.selectedProcedure.procedureLegs.find(leg2 =>
        leg2.startPoint.coordPoint.id == leg.startPoint.coordPoint.id &&
        leg2.endPoint.coordPoint.id == leg.endPoint.coordPoint.id);
      leg.direction = "NotSet";
      leg.offset = 0.0;
      this.procedureAssessmentsController.resetEspecificOffset(realLeg);
    }
    this.procedureAssessmentsController.procedureInterfaceToHTML.procedureCoordinatePoints.find(pcp =>
      leg.startPoint.coordPoint.id == pcp.coordPoint.id).isDeletedFromMap = false;
    this.procedureAssessmentsController.procedureInterfaceToHTML.procedureCoordinatePoints.find(pcp =>
      leg.endPoint.coordPoint.id == pcp.coordPoint.id).isDeletedFromMap = false;
  }

  public resetEspecificRedirectTo(pcp: ProcedureCoordinatePointModel){
    let selectedProcedurePointsCopy = cloneDeep(this.procedureAssessmentsController.selectedProcedure.procedureCoordinatePoints);
    this.procedureAssessmentsController.resetRedirectTo().then(function() {
      pcp.isDeletedFromMap = false;
      this.procedureAssessmentsController.procedureInterfaceToHTML.procedureLegs.forEach(leg => {
        if (!this.procedureAssessmentsController.legsNextToCurve.includes(leg)){
          leg.ismodified = false;
        }
      })

      this.procedureAssessmentsController.procedureInterfaceToHTML.procedureCoordinatePoints.forEach(currentPCP => {
        const legFound = selectedProcedurePointsCopy.some(pcp2 => pcp2.coordPoint.id == currentPCP.coordPoint.id);
        if (!legFound && currentPCP.coordPoint.id != pcp.coordPoint.id){
          this.procedureAssessmentsController.isResetPosition = true;
          this.redirectProcedure(currentPCP);
        }
      });

    }.bind(this)).then(function() {
      this.procedureAssessmentsController.updateProcedure(this.procedureAssessmentsController.selectedProcedure)}.bind(this));

  }

  public redirectProcedure(event: ProcedureCoordinatePointModel) : void {
    if (event.isDeletedFromMap){
      const pcpExists = this.procedureAssessmentsController.selectedProcedure.procedureCoordinatePoints.findIndex(pcp =>
        pcp.coordPoint.id == event.coordPoint.id) != -1;
      if (!pcpExists){
        this.resetEspecificRedirectTo(event);
        return;
      }
    }
    let currentLegs = this.procedureAssessmentsController.procedureInterfaceToHTML.procedureLegs.filter(leg =>
    leg.startPoint.coordPoint.id == event.coordPoint.id || leg.endPoint.coordPoint.id == event.coordPoint.id);

    let isFromOffSetLeg = false;
    currentLegs.forEach(currentLeg => {
      // case belongs to leg with offset
      if (currentLeg.direction != "NotSet" && currentLeg.offset != 0.0 && currentLeg.direction != null && currentLeg.offset != null ){
        this.modalService.showMesssageModal("Procedure Assessment", "It is not possible to remove a coordinate point belonging to an offset leg");
        isFromOffSetLeg = true;
        return;
      }
      // case where some point of current leg belongs to a leg with offset
      let otherLeg = null;
      if (currentLeg.startPoint.coordPoint.id == event.coordPoint.id){
        // get leg with same endpoint as current leg
        otherLeg =  this.procedureAssessmentsController.procedureInterfaceToHTML.procedureLegs.find(leg =>
          leg.startPoint.coordPoint.id == currentLeg.endPoint.coordPoint.id);
      } else {
        otherLeg =  this.procedureAssessmentsController.procedureInterfaceToHTML.procedureLegs.find(leg =>
          leg.endPoint.coordPoint.id == currentLeg.startPoint.coordPoint.id);
      }
      if (otherLeg != null && otherLeg.direction != "NotSet" && otherLeg.offset != 0.0 && otherLeg.direction != null && otherLeg.offset != null ){
        this.modalService.showMesssageModal("Procedure Assessment", "It is not possible to remove a coordinate point belonging to an offset leg");
        isFromOffSetLeg = true;
        return;
      }
    });
    if (!isFromOffSetLeg){
      this.procedureAssessmentsController.redirectProcedure(event.coordPoint.id);
      event.isDeletedFromMap = true;
      this.procedureAssessmentsController.procedureHasChanged = true;
      currentLegs.forEach(currentLeg => currentLeg.ismodified = true);
    }

  }

  public resetPositions(): void {
    this.procedureAssessmentsController.resetProcedureCoordinatePositions();
  }

  public resetRedirectTo(): void {

    this.procedureAssessmentsController.resetRedirectTo();
    this.procedureAssessmentsController.procedureInterfaceToHTML.procedureCoordinatePoints.forEach(pcp => {
      pcp.isDeletedFromMap = false;
    });
    this.procedureAssessmentsController.procedureInterfaceToHTML.procedureLegs.forEach(leg => {
      if (leg.direction != "NotSet" && leg.offset != 0.0 && leg.direction != null && leg.offset != null){ // leg has offset
        const pcpStart = this.procedureAssessmentsController.procedureInterfaceToHTML.procedureCoordinatePoints.find(pcp =>
          pcp.coordPoint.id == leg.startPoint.coordPoint.id);
        const pcpEnd = this.procedureAssessmentsController.procedureInterfaceToHTML.procedureCoordinatePoints.find(pcp =>
          pcp.coordPoint.id == leg.endPoint.coordPoint.id);
        pcpStart.isDeletedFromMap = true;
        pcpEnd.isDeletedFromMap = true;
      }
      if (!this.procedureAssessmentsController.legsNextToCurve.includes(leg)){
        leg.ismodified = false;
      }

    })
  }

  public updateOffset(event, index: number):void {
    const leg: ProcedureLegModel = this.procedureAssessmentsController.procedureInterfaceToHTML.procedureLegs[index];
    if (!leg.isstraightleg){
      return;
    }
    if (index+1<this.procedureAssessmentsController.procedureInterfaceToHTML.procedureLegs.length && !this.procedureAssessmentsController.procedureInterfaceToHTML.procedureLegs[index + 1].isstraightleg){
      return;
    }
    if (index-1 >= 0 && !this.procedureAssessmentsController.procedureInterfaceToHTML.procedureLegs[index - 1].isstraightleg){
      return;
    }
    if (leg.offset != 0.0 && leg.direction != "NotSet" && leg.direction != null && leg.offset != null ){

      let realLeg = this.procedureAssessmentsController.selectedProcedure.procedureLegs.find(leg2 =>
        leg2.startPoint.coordPoint.id == leg.startPoint.coordPoint.id &&
        leg2.endPoint.coordPoint.id == leg.endPoint.coordPoint.id);
      if (realLeg != undefined){
        realLeg.offset = leg.offset;
        realLeg.direction = leg.direction;
        //this.procedureAssessmentsController.loading = true;
        this.procedureAssessmentsController.updateOffset(event);
        this.procedureAssessmentsController.procedureInterfaceToHTML.procedureCoordinatePoints.find(pcp =>
          leg.startPoint.coordPoint.id == pcp.coordPoint.id).isDeletedFromMap = true;
        this.procedureAssessmentsController.procedureInterfaceToHTML.procedureCoordinatePoints.find(pcp =>
          leg.endPoint.coordPoint.id == pcp.coordPoint.id).isDeletedFromMap = true;
      }
      this.procedureAssessmentsController.procedureHasChanged = true;

    }

  }

  public resetOffsets(): void {
    //this.procedureAssessmentsController.resetOffsets();
    this.procedureAssessmentsController.selectedProcedure.procedureLegs.forEach(leg => {
      leg.ismodified = false;
      this.resetEspecificOffset(null, leg, true);
    })
  }

  public saveProcedure(): void {
    const bsModalRef : BsModalRef = this.popupService.show(SaveProcedureAssessmentComponent);
    bsModalRef.content.isFirstWindow = true;
    this.procedureAssessmentsController.offsetProcedure = cloneDeep(this.procedureAssessmentsController.selectedProcedure);

  }

  checkIfSave() : boolean  {
    if (this.procedureAssessmentsController.selectedProcedure.procedureCoordinatePoints.length != this.procedureAssessmentsController.procedureInterfaceToHTML.procedureCoordinatePoints.length){
      return true;
    }
    for (const pcp of this.procedureAssessmentsController.procedureInterfaceToHTML.procedureCoordinatePoints){
      if (pcp.coordPoint.ismodified){
        return true;
      }
    }
    for (const leg of this.procedureAssessmentsController.procedureInterfaceToHTML.procedureLegs){
      if (leg.direction != "NotSet" && leg.offset != 0.0 && leg.direction != null && leg.offset != null){
        return true;
      }
    }
    return false;
  }

}
